import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../actions/commonActions";
import { FETCH_EVENTS_FAILURE, FETCH_EVENTS_REQUEST, FETCH_EVENTS_SUCCESS } from "../actions/eventsActions";

  const initialState = {
    eventsData: [],
    eventsloading: true,
    eventsError: null,
  };
  
  const eventsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_EVENTS_REQUEST:
        return { ...state, eventsloading: true , payload: action.payload};
      case FETCH_EVENTS_SUCCESS:
        return { ...state, eventsloading: false, eventsData: action.payload };
      case FETCH_EVENTS_FAILURE:
        return { ...state, eventsloading: false, eventsError: action.payload };       
      default:
        return state;
    }
  };
  
  export default eventsReducer;
  